import { Container, ImgBox, BoxText } from "./style";
import PlanetText from "../../../../assets/img/Langding/PlanetText.png";
const Planet = () => {
  return (
    <Container>
      <ImgBox></ImgBox>
      <BoxText>
        <div>
          <h6>Carbon Crisis Destroy the</h6>
          <img src={PlanetText} alt="planet" />
        </div>
        <p>
          Carbon dioxide concentration at record high 414 ppm (2021) <br />{" "}
          Earth's average temperature increased by 1.2% since 19th Ocean acidity
          increased by 26% since industrial Revolution <br /> Air pollution
          causes 7M premature deaths annually, affect 91% of the world's
          population.
          <br />
          Deforestation accounts for 10% of global greenhouse gas emissions.
        </p>
      </BoxText>
    </Container>
  );
};
export default Planet;
